const REPORT_HITS_PER_PAGE = 30;

class ReportsService {
  static instance = null;

  static getInstance() {
    if (!ReportsService.instance) {
      ReportsService.instance = new ReportsService();
    }
    return ReportsService.instance;
  }

  constructor() {
    this.baseUrl = import.meta.env.VITE_REPORTS_API_BASE_URL || "";
  }

  getHitsPerPage() {
    return REPORT_HITS_PER_PAGE;
  }

  async searchReports({
    query = "*",
    page = 1,
    report = "",
    reportYear = "",
    judgmentYear = "",
    volume = "",
    token = "",
  }) {
    const response = await fetch(`${this.baseUrl}/api/reports/search`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({
        q: query?.trim() || "*",
        page,
        per_page: REPORT_HITS_PER_PAGE,
        report: report || null,
        report_year: reportYear ? Number(reportYear) : null,
        judgment_year: judgmentYear ? Number(judgmentYear) : null,
        volume: volume || null,
      }),
    });

    if (response.status === 401) {
      throw new Error("AUTH_REQUIRED");
    }

    if (!response.ok) {
      throw new Error(`Failed to load reports: ${response.status}`);
    }

    return response.json();
  }
}

export default ReportsService;